import clsx from 'clsx';
import { PhiaMark } from './PhiaMark';
import styles from './FAB.module.css';

type Props = {
  onClick: () => void;
  unread?: number;
  hidden?: boolean;
};

export function FAB({ onClick, unread, hidden }: Props) {
  return (
    <button
      type="button"
      aria-label="Abrir tutor AI"
      className={clsx(styles.fab, hidden && styles.hidden)}
      onClick={onClick}
      tabIndex={hidden ? -1 : 0}
    >
      <PhiaMark className={styles.mark} />
      {unread != null && unread > 0 && (
        <span className={styles.badge}>{unread > 9 ? '9+' : unread}</span>
      )}
    </button>
  );
}
